module.exports = __webpack_public_path__ + "static/img/公司5.4087f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司5.jpg
// module id = v3ZR
// module chunks = 1